export enum DataSourceType {
    timeStampedData = 0,
    userData,
    caseData,
    behaviorData,
    activityData,
    taskData,
    subtaskData,
    masterData
}

export class DataSourceTypeUtil {

    public static toString(dataType: DataSourceType): string {
      let value = 'Unknown';

      switch (dataType) {
        case DataSourceType.activityData:
          value = 'Actyvity Data';
          break;
          case DataSourceType.taskData:
            value = 'Task Data';
            break;
        case DataSourceType.subtaskData:
          value = 'Subtask Data';
          break;
          case DataSourceType.caseData:
          value = 'Case Data';
          break;
        case DataSourceType.userData:
          value = 'User Data';
          break;
        case DataSourceType.timeStampedData:
          value = 'Time-Stamped Data';
          break;
        case DataSourceType.behaviorData:
          value = 'Behavior Data';
          break;
          case DataSourceType.masterData:
          value = 'Master Data';
          break;
      }

      return value;
    }
}
